import Global from '@/scripts/Global';
import VueSignals from '@/scripts/VueSignals';
import SessionManager from '@/Manager/Session.manager';
import MessageExcerpt from './MessageExcerpt/MessageExcerpt.vue';
import config from '@/scripts/config';
export default {
    name: 'ChannelThumbNail',
    data: function() {
        return {
            defaultUserImage: config.DEFAULT_USER_IMAGE,
        }
    },
    props: {
        channel: Object,
        activeChannelDoc: Object,
        arrMentions: Array,
        loggedInUserDoc: {
            type: Object,
            default: _ => {
                return SessionManager.getLoggedInUser();
            }
        }
    },
    computed: {
        mentions() {
            for (var i = 0; i < this.arrMentions.length; i++) {
                if (this.arrMentions[i].channel_id == this.channel.channel_id) {
                    return this.arrMentions[i].count;
                }
            }
            return 0;
        }
    },
    components: {
        MessageExcerpt
    },
    filters: {
        formatName(name) {
            //24?
            return name ? (name.length >= 31 ? `${name.slice(0,31)}..` : name) : '';
        }
    },
    methods: {
        getReachability(channel) {
            if (channel.channel_name == 'CloudBot' || channel.channel_name == 'Feedback') {
                return 'online';
            } else {
                let user_id = channel.user_ids.filter(id => id !== SessionManager.getLoggedInUserId())[0];
                let reachability = this.getUserData(user_id).reachability;
                return reachability ? reachability : 'offline'
            }
        },
        getUserData(user_id) {
            if (user_id != SessionManager.getLoggedInUserId()) {
                let user = SessionManager.getUser(user_id)
                if (typeof user == 'undefined') {
                    return
                }
                if (this.activeChannelDoc.hasOwnProperty('removed_users')) {
                    if (this.activeChannelDoc.removed_users.indexOf(user.user_id) > -1) {
                        user.removed = true
                    } else {
                        user.removed = false
                    }
                }
                return user
            } else if (user_id == SessionManager.getLoggedInUserId()) {
                return SessionManager.getLoggedInUser()
            }
        },
        getProfilePicture(channel) {
            return Global.getChannelPicture(channel);
        },
        getChannelLastMessage(channel) {
            if (channel.flag == 'deleted') {
                return this.$t('deleted');
            }
            let message = '';
            if (channel.last_message && channel.last_message.length > 0) {
                message = channel.last_message[0].origin;
            } else {
                message = this.$t('No Messages');
            }
            return message;
        },
        getMessageTime(channel) {
            let today = new Date().toLocaleDateString(this.$i18n.locale);
            let yesterday = new Date(new Date().setDate(new Date().getDate() - 1)).toLocaleDateString(this.$i18n.locale);
            let sevenDays = new Date(new Date().setDate(new Date().getDate() - 7)).toLocaleDateString(this.$i18n.locale);

            let timestamp = '';
            if (channel.latest_message_at) {
                timestamp = channel.latest_message_at;
            } else if (channel.last_message && channel.last_message.length > 0) {
                timestamp = channel.last_message[0].created_at;
            }
            if (!timestamp) return '';

            let messageDate = new Date(timestamp * 1000).toLocaleDateString(this.$i18n.locale);

            // Today
            if (messageDate == today) {
                return new Date(timestamp * 1000).toLocaleTimeString(this.$i18n.locale, {hour: '2-digit', minute:'2-digit'});
            } else if (messageDate == yesterday) {
                return this.$t('Yesterday');
            } else if (messageDate < yesterday && messageDate >= sevenDays) {
                return new Date(timestamp * 1000).toLocaleDateString(this.$i18n.locale, {
                    weekday: 'long'
                });
            } else {
                return new Date(timestamp * 1000).toLocaleDateString(this.$i18n.locale, {
                    year: '2-digit',
                    month: '2-digit',
                    day: '2-digit',
                });
            }
        },
        checkIfSelfChannel(channel) {
            return channel.user_ids[0] == channel.user_ids[1] && channel.user_ids[0] == this.loggedInUserDoc.user_id;
        }
    }
}
